






















































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import DButton from '@/components/DButton/button.vue';
import { UniversalData } from "@/services/models-service";
import DxPopup from "devextreme-vue/popup";

@Component({
  name: "ChoicePopup",
  components: {
    DxPopup,
    DButton,
  }
})
export default class extends Vue {
@PropSync('popupOptions') public localPopupOptions: any;
@PropSync('data') public universalData: UniversalData;
@PropSync('recalcDisable') public disableReCalc: boolean;
@PropSync('confirmDisable') public disableDontCalc: boolean; 

async created() {

}

async mounted() {

}

async onShowing() {

}

get popupTitle() {
    const mesure = this.localPopupOptions.volume ? 'Изменение объема ' : 'Изменение cтоимости ';
    const energy_kind = this.localPopupOptions.te ? 'тепловой энергии' : 'мощности';
    return mesure + energy_kind
}

get tooltipCalc () {
    if (this.localPopupOptions.te && this.localPopupOptions.volume) {
        const oldVolume = this.universalData.cost_te / this.localPopupOptions.tariff;
        const oldCost = this.localPopupOptions.tariff * oldVolume;
        const newCost = this.localPopupOptions.tariff * this.universalData.vol_te;
        return `Применить <b>Объем тэ = ${this.universalData.vol_te}</b> и изменить <b>Стоимость тэ (итого)</b> с <b>${oldCost}</b> на <b>${newCost}<b>`
    }
    if (this.localPopupOptions.power && this.localPopupOptions.volume) {
        const oldVolume = this.universalData.cost_power * 1000 / this.localPopupOptions.tariff;
        const oldCost = this.localPopupOptions.tariff * oldVolume / 1000;
        const newCost = this.localPopupOptions.tariff * this.universalData.vol_power / 1000;
        return `Применить <b>Объем мощности = ${this.universalData.vol_power}</b> и изменить <b>Стоимость мощности (итого)</b> с <b>${oldCost}</b> на <b>${newCost}</b>`
    }
    if (this.localPopupOptions.te && this.localPopupOptions.cost) {
        const oldCost = this.universalData.vol_te * this.localPopupOptions.tariff;
        const oldVolume = oldCost / this.localPopupOptions.tariff;
        const newVolume = this.universalData.cost_te / this.localPopupOptions.tariff;
        return `Применить <b>Стоимость тэ (итого) = ${this.universalData.cost_te}</b> и изменить <b>Объем тэ</b> с <b>${oldVolume}</b> на <b>${newVolume}</b>`
    }
    if (this.localPopupOptions.power && this.localPopupOptions.cost) {
        const oldCost = this.universalData.vol_power * this.localPopupOptions.tariff / 1000;
        const oldVolume = oldCost * 1000 / this.localPopupOptions.tariff;
        const newVolume = this.universalData.cost_power * 1000 / this.localPopupOptions.tariff;
        return `Применить <b>Стоимость мощности (итого) = ${this.universalData.cost_power}</b> и изменить <b>Объем мощности</b> с <b>${oldVolume}</b> на <b>${newVolume}</b>`
    }

    return '';
}

get tooltipDOntCalc () {
    if (this.localPopupOptions.te && this.localPopupOptions.volume) {
        const delta = (this.universalData.vol_te * this.localPopupOptions.tariff) - this.universalData.cost_te;
        return `Применить <b>Объем тэ = ${this.universalData.vol_te}</b> и изменить <b>Стоимость тэ (корректировка) с ${this.universalData.cost_delta_te} на ${delta}</b>`
    }
    if (this.localPopupOptions.power && this.localPopupOptions.volume) {
        const delta = (this.universalData.vol_power * this.localPopupOptions.tariff / 1000) - this.universalData.cost_power;
        return `Применить <b>Объем мощности = ${this.universalData.vol_power}</b> и изменить <b>Стоимость мощности (корректировка) с ${this.universalData.cost_delta_power} на ${delta}</b>`
    }
    if (this.localPopupOptions.te && this.localPopupOptions.cost) {
        const delta =  (this.universalData.vol_te * this.localPopupOptions.tariff) - this.universalData.cost_te;
        return `Применить <b>Стоимость тэ (итого) = ${this.universalData.cost_te}</b> и изменить <b>Стоимость тэ (корректировка) с ${this.universalData.cost_delta_te} на ${delta}</b>`
    }
    if (this.localPopupOptions.power && this.localPopupOptions.cost) {
        const delta = (this.universalData.vol_power * this.localPopupOptions.tariff / 1000) - this.universalData.cost_power;
        return `Применить <b>Стоимость мощности (итого) = ${this.universalData.cost_power}</b> и изменить <b>Стоимость мощности (корректировка) с ${this.universalData.cost_delta_power} на ${delta}</b>`
    }

    return '';
}

reCalc() {
    if (this.localPopupOptions.te && this.localPopupOptions.volume) {
        this.universalData.cost_te = this.universalData.vol_te * this.localPopupOptions.tariff;
        this.universalData.cost_delta_te = 0;
    }
    if (this.localPopupOptions.power && this.localPopupOptions.volume) {
        this.universalData.cost_power = this.universalData.vol_power * this.localPopupOptions.tariff / 1000;
        this.universalData.cost_delta_power = 0;
    }
    if (this.localPopupOptions.te && this.localPopupOptions.cost) {
        if (this.universalData.vol_te * this.localPopupOptions.tariff !== this.universalData.cost_te) {
            this.universalData.vol_te = this.universalData.cost_te / this.localPopupOptions.tariff;
            this.universalData.cost_delta_te = 0
        }
    }
    if (this.localPopupOptions.power && this.localPopupOptions.cost) {
        if (this.universalData.vol_power * this.localPopupOptions.tariff / 1000 !== this.universalData.cost_power) {
            this.universalData.vol_power = this.universalData.cost_power * 1000 / this.localPopupOptions.tariff;
            this.universalData.cost_delta_power = 0
        }
    }
    this.universalData.cost_total = this.universalData.cost_te + this.universalData.cost_power;
    this.onClose();
}

dontCalc() {
    if (this.localPopupOptions.te && this.localPopupOptions.volume) {
        this.universalData.cost_delta_te = (this.universalData.vol_te * this.localPopupOptions.tariff) - this.universalData.cost_te;
    }
    if (this.localPopupOptions.power && this.localPopupOptions.volume) {
        this.universalData.cost_delta_power = (this.universalData.vol_power * this.localPopupOptions.tariff / 1000) - this.universalData.cost_power;
    }
    if (this.localPopupOptions.te && this.localPopupOptions.cost) {
        if (this.universalData.vol_te * this.localPopupOptions.tariff !== this.universalData.cost_te) {
            this.universalData.cost_delta_te =  (this.universalData.vol_te * this.localPopupOptions.tariff) - this.universalData.cost_te;
        }
    }
    if (this.localPopupOptions.power && this.localPopupOptions.cost) {
        if (this.universalData.vol_power * this.localPopupOptions.tariff / 1000 !== this.universalData.cost_power) {
            this.universalData.cost_delta_power = (this.universalData.vol_power * this.localPopupOptions.tariff / 1000) - this.universalData.cost_power;
        }
    }
    this.universalData.cost_total = this.universalData.cost_te + this.universalData.cost_power;
    this.onClose();
}

onCancel() {
    if (this.localPopupOptions.te && this.localPopupOptions.volume) {
        if (this.universalData.cost_delta_te !== 0) {
            this.universalData.vol_te = (this.universalData.cost_te + this.universalData.cost_delta_te) / this.localPopupOptions.tariff;
        } else {
            this.universalData.vol_te = this.universalData.cost_te / this.localPopupOptions.tariff;
        }
    }
    if (this.localPopupOptions.power && this.localPopupOptions.volume) {
        if (this.universalData.cost_delta_power !== 0) {
            this.universalData.vol_power = (this.universalData.cost_power + this.universalData.cost_delta_power) * 1000 / this.localPopupOptions.tariff;
        } else {
            this.universalData.vol_power = this.universalData.cost_power * 1000 / this.localPopupOptions.tariff;
        }
    }
    if (this.localPopupOptions.te && this.localPopupOptions.cost) {
        if (this.universalData.cost_delta_te !== 0) {
            this.universalData.cost_te = this.universalData.vol_te * this.localPopupOptions.tariff - this.universalData.cost_delta_te;
        } else {
            this.universalData.cost_te = this.universalData.vol_te * this.localPopupOptions.tariff;
        }
    }
    if (this.localPopupOptions.power && this.localPopupOptions.cost) {
        if (this.universalData.cost_delta_power !== 0) {
            this.universalData.cost_power = this.universalData.vol_power * this.localPopupOptions.tariff / 1000 - this.universalData.cost_delta_power;
        } else {
            this.universalData.cost_power = this.universalData.vol_power * this.localPopupOptions.tariff / 1000;
        }
    }
    this.universalData.cost_total = this.universalData.cost_te + this.universalData.cost_power;
    this.onClose();
}


onClose() {
    this.localPopupOptions.visible = false;
    this.localPopupOptions.tariff = 1;
    this.localPopupOptions.te = false;
    this.localPopupOptions.power = false;
    this.localPopupOptions.volume = false;
    this.localPopupOptions.cost = false;
    this.$emit('close', this.universalData);
}

}
